module.exports = __webpack_public_path__ + "img/document-text.15390b9c.svg";